(function () {
    'use strict';

    angular
        .module('app')
        .controller('DocumentTemplateEditCtrl', DocumentTemplateEditCtrl);

    DocumentTemplateEditCtrl.$inject = [
        '$location',
        '$scope',
        '$q',
        '$routeParams',
        '$window',
        'DocumentTemplatesService',
        'EntityTemplatesService',
        'DmsService',
        'LastUpdatedService',
        'NavigationAidService',
        'DialogService',
        'TagsService',
        'UnsavedChangesService',
        'DocumentTemplate',
        'TestMerge',
        'FileSelectorService',
        'ChilliUserProfileService',
        'FieldSelectorService',
        'ObjectSaveErrorHandlerService',
        'WindowTitleService'];

    /**
     * @ngdoc controller
     * @name DocumentTemplateEditCtrl
     *
     * @description
     * Edit screen for a document template. Add a new one, or edit an existing one.
     */
    function DocumentTemplateEditCtrl(
        $location,
        $scope,
        $q,
        $routeParams,
        $window,
        DocumentTemplatesService,
        EntityTemplatesService,
        DmsService,
        LastUpdatedService,
        NavigationAidService,
        DialogService,
        TagsService,
        UnsavedChangesService,
        DocumentTemplate,
        TestMerge,
        FileSelectorService,
        ChilliUserProfileService,
        FieldSelectorService,
        ObjectSaveErrorHandlerService,
        WindowTitleService) {

        /* jshint validthis:true */
        var vm = this;
        vm.fileNameRegex = '[^/\\\\?%*:|"<>.]*';
        vm.tagsControl = {};
        vm.documentTemplate = {};
        vm.entityTemplates = [];
        vm.saveDocumentTemplate = saveDocumentTemplate;
        vm.copyDocumentTemplate = copyDocumentTemplate;
        vm.deleteDocumentTemplate = deleteDocumentTemplate;
        vm.saveDocumentTemplateValidate = saveDocumentTemplateValidate;
        vm.loading = true;
        vm.notFound = false;
        vm.permissionDenied = false;
        vm.downloadTemplate = downloadTemplate;
        vm.uploadTemplate = uploadTemplate;
        vm.removeTemplate = removeTemplate;
        vm.nameBlur = nameBlur;
        vm.descriptionBlur = descriptionBlur;
        vm.viewEntities = viewEntities;
        vm.getSelectedEntityTemplateName = getSelectedEntityTemplateName;
        Object.defineProperty(vm, 'documentTemplateUsageTypes', {
            get: getDocumentTemplateUsageTypes
        });
        Object.defineProperty(vm, 'downloadTemplateEnabled', {
            get: getDownloadTemplateEnabled
        });
        Object.defineProperty(vm, 'dirty', {
            get: function () { return !_.isNil(UnsavedChangesService) && UnsavedChangesService.dirty; }
        });
        vm.testMerge = testMerge;
        vm.close = close;
        Object.defineProperty(vm, 'deleteEnabled', {
            get: function () { return !_.isNil(vm.documentTemplate) && !_.isNil(vm.documentTemplate.data) && !_.isNil(vm.documentTemplate.data.Id) && vm.documentTemplate.data.Id != 'new'; }
        });
        Object.defineProperty(vm, 'selectedEntityTemplate', {
            get: getSelectedEntityTemplate,
            set: setSelectedEntityTemplate
        });
        Object.defineProperty(vm, 'lastUpdatedLabel', {
            get: function () {
                return LastUpdatedService.getLabel(vm.documentTemplate.data);
            }
        });
        Object.defineProperty(vm, 'documentTemplateIsNew', {
            get: function () { return !($routeParams.id && $routeParams.id !== 'new'); }
        });
        Object.defineProperty(vm, 'saveToFieldInvalid', {
            get: function () {
                return !_.isNil(vm.documentTemplate) && !_.isNil(vm.documentTemplate.data) && !vm.documentTemplate.data.SaveToCurrentEntity && !vm.documentTemplate.data.SaveToOrganisation && !vm.documentTemplate.data.SaveToCurrentUser &&
                    !(!_.isNil(vm.documentTemplate.data.SaveToEntities) && vm.documentTemplate.data.SaveToEntities.length > 0); }
        });
        vm.viewTitle = 'Document Template';
        vm.currentTabPage = 'details';
        vm.testMergeModel = new TestMerge();
        vm.FieldSelectorService = FieldSelectorService;
        vm.selectedEntityTemplateFields = [];
        vm.copyFieldExpression = copyFieldExpression;

        activate();

        function activate() {
            updateViewTitle();

            NavigationAidService.watchTabPage($scope, 'vm.currentTabPage');

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadEverything,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () {
                    vm.loading = false;
                    updateViewTitle();

                    var currentTabFromHistory = NavigationAidService.getCurrentTabPage();
                    if (!_.isNil(currentTabFromHistory)) {
                        // Load tab page from history
                        vm.currentTabPage = currentTabFromHistory;
                    }
                }
            });
        }

        function loadEverything() {
            var docTemplatePromise = loadDocumentTemplate();
            var entityTemplatesPromise = loadEntityTemplates();
            var tagsPromise = loadTags();

            // Load the file details in the background
            docTemplatePromise.then(function () {
                vm.documentTemplate.loadFileDetails();
            });

            // If the usage type is changed and the output format is no longer valid, the output format select control will show blank however the value would not have changed.
            // With this watch OutputFormat will be set to a blank string if it is no longer valid after usage type has changed.
            $scope.$watch('vm.documentTemplate.data.UsageType', function (newVal, oldVal) {
                if (!vm.loading && !_.isNil(vm.documentTemplate) && !_.isNil(vm.documentTemplate.data) && !_.isNil(vm.documentTemplate.data.OutputFormat)) {
                    if (!_.some(vm.documentTemplate.validOutputFormats, function (validOutputFormat) {
                        return validOutputFormat === vm.documentTemplate.data.OutputFormat;
                    })) {
                        vm.documentTemplate.data.OutputFormat = '';
                    }
                }
            });

            return $q.all([docTemplatePromise, entityTemplatesPromise, tagsPromise]).then(function () {
                // Finish view-model configuration once everything critical is loaded
                UnsavedChangesService.register({
                    scope: $scope,
                    getDirtyFunction: getModelDirty,
                    saveFunction: saveDocumentTemplateValidate,
                    unsavedItemName: 'Document Template'
                });
            });
        }


        /**
         * Copy the selected field expression to the clipboard.
         */
        function copyFieldExpression() {
            if (vm.selectedEntityTemplateFields.length > 0) {
                var body = angular.element($window.document.body);
                var textarea = angular.element('<textarea/>');
                textarea.css({
                    position: 'fixed',
                    opacity: '0'
                });

                textarea.val(vm.selectedEntityTemplateFields[0]);
                body.append(textarea);
                textarea[0].select();

                try {
                    var successful = document.execCommand('copy');
                    if (!successful) throw successful;
                } catch (err) {
                    window.prompt("Copy to clipboard: Ctrl+C", vm.selectedEntityTemplateFields[0]);
                }

                textarea.remove();
            }
        }

        /**
         * Load document template into vm.documentTemplate.
         *
         * @returns {Promise} A promise resolved once loading is finished. Rejects if load fails.
         */
        function loadDocumentTemplate() {
            var getDocTemplatePromise;
            if (!vm.documentTemplateIsNew) {
                getDocTemplatePromise = DocumentTemplate.get($routeParams.id);
            } else if ($routeParams.copyDocumentTemplateId) {
                getDocTemplatePromise = DocumentTemplate.getCopy($routeParams.copyDocumentTemplateId);
            } else {
                getDocTemplatePromise = DocumentTemplate.getNew(parseInt($routeParams.entityTemplateId));
            }

            return getDocTemplatePromise.then(
                function ok(doc) {
                    vm.documentTemplate = doc;
                },
                function error(response) {
                    if (response.status === 404) {
                        vm.notFound = true;
                    } else {
                        DialogService.error('Error fetching Document Template', response);
                    }
                    return $q.reject(response);
                });
        }

        /**
         * Load entity templates and entity template count into vm.entityTemplates and vm.entityTemplatesCount.
         *
         * @returns {Promise} A promise resolved once loading is finished, resolves regardless of error.
         */
        function loadEntityTemplates() {
            return EntityTemplatesService.query()
                .then(getEntityTemplatesOk, getEntityTemplatesError);

            function getEntityTemplatesOk(data) {
                vm.entityTemplates = data.EntityTemplates;
            }

            function getEntityTemplatesError(response) {
                DialogService.error('Error fetching Entity Templates', response);
            }
        }

        /**
         * Load tags into vm.tags.
         *
         * @returns {Promise} A promise resolved once loading is finished, resolves regardless of error.
         */
        function loadTags() {
            return TagsService.query({ tagUsage: 'File' })
                .then(getTagsOk, getTagsError);

            function getTagsOk(data) {
                vm.tags = data.Tags;
            }

            function getTagsError(response) {
                DialogService.error('Error fetching Tags', response);
            }
        }

        /**
         * Update Title to be shown at the top of the view and browser window/tab title.
         */
        function updateViewTitle() {
            var title = 'Document Template';

            if (!_.isNil($routeParams.id) && $routeParams.id === 'new') {
                title = 'Add ' + title;
            }

            if (!_.isNil(vm.documentTemplate) && !_.isNil(vm.documentTemplate.data) && !_.isNil(vm.documentTemplate.data.Name) && vm.documentTemplate.data.Name !== '') {
                title += ' - ' + vm.documentTemplate.data.Name;
            }

            vm.viewTitle = title;
            WindowTitleService.setTitle(title);
        }

        /**
         * @returns {bool} True if the model is dirty aka there are unsaved changes.
         */
        function getModelDirty() {
            return vm.documentTemplate !== null && vm.documentTemplate.dirty;
        }

        function saveDocumentTemplateValidate() {
            var documentTemplate = angular.copy(vm.documentTemplate.data);

            if (vm.documentTemplate.fileDetails.Mode === 'txt' && vm.documentTemplate.dirtyFileDetails) {
                documentTemplate.FileString = vm.documentTemplate.fileDetails.Txt;
                documentTemplate.FileMode = vm.documentTemplate.fileDetails.Mode;
            } else if (vm.documentTemplate.fileDetails.Mode === 'html' && vm.documentTemplate.dirtyFileDetails) {
                documentTemplate.FileString = vm.documentTemplate.fileDetails.Html;
                documentTemplate.FileMode = vm.documentTemplate.fileDetails.Mode;
            } else if (vm.documentTemplate.fileDetails.File !== null && vm.documentTemplate.fileDetails.File !== undefined) {
                var fileNameParts = vm.documentTemplate.fileDetails.File.name.split('.');
                documentTemplate.FileMode = fileNameParts.length > 1 ? fileNameParts.pop() : '';
            } else {
                // If there is no Txt, Html or file document template to validate, skip the validation call
                return vm.saveDocumentTemplate();
            }

            return DocumentTemplatesService.validateDocumentTemplate(documentTemplate, vm.documentTemplate.fileDetails.File)
                .then(saveDocumentTemplateValidateOk, saveDocumentTemplateValidateError);
        }

        function saveDocumentTemplateValidateOk() {
            return vm.saveDocumentTemplate();
        }

        function saveDocumentTemplateValidateError(response) {
            DialogService.error('Error saving Document Template', response);
            return $q.reject(response);
        }

        /**
         * Save the document template, including field data (name, etc.) and the document template file.
         *
         * @returns {Promise} A promise that resolves once saving is finished.
         */
        function saveDocumentTemplate() {
            var saveRequest;

            if (!_.isNil(vm.addDocumentTemplateForm) && vm.addDocumentTemplateForm.$invalid) {
                return DialogService.messageList('Error saving document template', null, vm.addDocumentTemplateForm.$error)
                    .then(function () {
                        return $q.reject();
                    });
            } else {

                saveRequest = angular.copy(vm.documentTemplate.data);

                if (vm.documentTemplate.fileDetails.Mode === 'txt' && vm.documentTemplate.dirtyFileDetails) {
                    saveRequest.FileString = vm.documentTemplate.fileDetails.Txt;
                    saveRequest.FileMode = vm.documentTemplate.fileDetails.Mode;
                }

                if (vm.documentTemplate.fileDetails.Mode === 'html' && vm.documentTemplate.dirtyFileDetails) {
                    saveRequest.FileString = vm.documentTemplate.fileDetails.Html;
                    saveRequest.FileMode = vm.documentTemplate.fileDetails.Mode;
                }

                if (vm.documentTemplate.fileDetails.Mode !== 'txt' &&
                    vm.documentTemplate.fileDetails.Mode !== 'html' &&
                    vm.documentTemplate.dirtyFileDetails) {

                    if (_.isNil(vm.documentTemplate.fileDetails.File)) {
                        // File has been removed from the document template, therefore set template to blank.
                        saveRequest.Template = '';
                        return DocumentTemplatesService.saveDocumentTemplate(saveRequest)
                            .then(saveDocumentTemplateOk, saveDocumentTemplateError);
                    } else {
                        // Persist file to DMS, then save template details

                        var fileNameParts = vm.documentTemplate.fileDetails.File.name.split('.');
                        var fileExtension = fileNameParts.length > 1 ? fileNameParts.pop() : '';

                        var fileName = '';
                        while (fileNameParts.length > 0) {
                            fileName += fileNameParts.pop();
                            if (fileNameParts.length > 0) {
                                fileName += '.';
                            }
                        }

                        var fileMetaData = {
                            Id: vm.documentTemplate.data.Template,
                            FileNameWithoutExtension: fileName,
                            FileExtension: fileExtension,
                            UpdatedDate: new Date()
                        };

                        return DmsService.saveFile(fileMetaData, vm.documentTemplate.fileDetails.File)
                            .then(saveFileOk, saveFileError);
                    }
                } else {

                    // No file to persist, just save template details

                    return DocumentTemplatesService.saveDocumentTemplate(saveRequest)
                        .then(saveDocumentTemplateOk, saveDocumentTemplateError);
                }
            }

            function saveFileOk(savedFile) {
                saveRequest.Template = savedFile.Id;

                return DocumentTemplatesService.saveDocumentTemplate(saveRequest)
                    .then(saveDocumentTemplateOk, saveDocumentTemplateError);
            }

            function saveFileError(response) {
                DialogService.error('Error saving Document Template file', response);
                return $q.reject(response);
            }

            function saveDocumentTemplateOk(response) {
                if (vm.documentTemplateIsNew) {
                    UnsavedChangesService.clearRegistration();
                    NavigationAidService.replacePage('documenttemplates/' + response);
                } else {
                    return DocumentTemplate.createWithData(response)
                        .then(function (documentTemplate) {
                            vm.tagsControl.refresh();
                            vm.documentTemplate = documentTemplate;
                            return vm.documentTemplate.loadFileDetails()
                                .then(function () {
                                    vm.addDocumentTemplateForm.$setPristine();

                                    UnsavedChangesService.register({
                                        scope: $scope,
                                        getDirtyFunction: getModelDirty,
                                        saveFunction: saveDocumentTemplate,
                                        unsavedItemName: 'Document Template'
                                    });

                                    updateViewTitle();
                                });
                        });
                }
            }

            function saveDocumentTemplateError(response) {
                return ObjectSaveErrorHandlerService.handleObjectSaveError(
                    response,
                    vm.documentTemplate.data,
                    'Document Template',
                    vm.saveDocumentTemplate,
                    function () {
                        return DocumentTemplate.get($routeParams.id)
                            .then(function (getDocTemplateResponse) {
                                return getDocTemplateResponse.data;
                            });
                    });
            }
        }

        /**
         * Deletes the document template. The user is presented with a confirmation dialog.
         *
         * NB: This function is asynchronous.
         */
        function deleteDocumentTemplate() {
            if ($routeParams.id && $routeParams.id !== 'new') {
                vm.documentTemplate.delete()
                    .then(deleteDocumentTemplateOk, deleteDocumentTemplateError);
            } else {
                promptUserToSaveForOperation('deleting');
            }

            function deleteDocumentTemplateOk(success) {
                NavigationAidService.goBack();
            }

            function deleteDocumentTemplateError(response) {
                if (!_.isNil(response)) {
                    DialogService.error('Error deleting Document Template', response);
                }
            }
        }

        /**
         * Present the user with a Save As / Download dialog for the document template file.
         */
        function downloadTemplate() {
            DocumentTemplate.downloadTemplate(vm.documentTemplate);
        }

        /**
         * @returns {Bool} true if the download template functionality should be enabled
         */
        function getDownloadTemplateEnabled() {
            return vm.documentTemplate !== null && vm.documentTemplate.fileDetails.Mode !== undefined && vm.documentTemplate.fileDetails.Mode !== 'txt' && vm.documentTemplate.fileDetails.Mode !== 'html';
        }

        /**
         * @returns {array} Returns the list of document template usage types.
         */
        function getDocumentTemplateUsageTypes() {
            var usageTypes = _.map(DocumentTemplate.UsageTypes, function (item) { return item; });

            if (!angular.equals(getDocumentTemplateUsageTypes.usageTypes, usageTypes)) {
                getDocumentTemplateUsageTypes.usageTypes = usageTypes;
            }

            return getDocumentTemplateUsageTypes.usageTypes;
        }

        function getSelectedEntityTemplate() {
            if (_.isNil(vm.documentTemplate) || _.isNil(vm.documentTemplate.data) || _.isNil(vm.documentTemplate.data) || _.isNil(vm.documentTemplate.data.EntityTemplateId) || vm.documentTemplate.data.EntityTemplateId === '') {
                return null;
            } else {
                var searchResult = _.find(vm.entityTemplates, function (i) { return i.Id === vm.documentTemplate.data.EntityTemplateId; });
                return angular.isUndefined(searchResult) ? null : searchResult;
            }
        }

        function setSelectedEntityTemplate(newTemplate) {
            if (newTemplate === null) {
                vm.documentTemplate.data.EntityTemplateId = null;
            } else {
                vm.documentTemplate.data.EntityTemplateId = newTemplate.Id;
            }
        }

        /**
         * Display a selection dialog for uploading a document template file.
         */
        function uploadTemplate() {
            var validFileExtensions = ['docx', 'doc', 'pdf'];

            FileSelectorService.selectLocalFileDialog(false, validFileExtensions).then(function (fileSelection) {
                if (fileSelection.length > 0) {
                    var validFile = false;
                    var extension = null;

                    if (fileSelection[0].FileName.indexOf('.') !== -1) {
                        extension = fileSelection[0].FileName.split('.').pop().toLowerCase();
                        if (validFileExtensions.indexOf(extension) !== -1) {
                            validFile = true;
                        }
                    }

                    if (validFile) {
                        // If the current document template file is doc, docx or pdf, warn the user that the old file will be replaced.
                        // Also if the old and new file are both pdf, ask the user if they wish to keep the pdf insertion details.
                        if (!_.isNil(vm.documentTemplate.fileDetails.File) && (vm.documentTemplate.fileDetails.Mode === 'docx' || vm.documentTemplate.fileDetails.Mode === 'doc' || vm.documentTemplate.fileDetails.Mode === 'pdf')) {
                            DialogService.show({
                                locals: { showPreservePdfInsertionDetails: extension === 'pdf' && vm.documentTemplate.fileDetails.Mode === 'pdf' },
                                controller: 'ReplaceDocumentTemplateFileConfirmationCtrl',
                                controllerAs: 'vm',
                                templateUrl: 'app/documenttemplate/replace-document-template-file-confirmation-dialog.tmpl.html'
                            })
                            .then(function (details) {
                                vm.documentTemplate.setFile(extension, fileSelection[0].File, details.PreservePdfInsertionDetails);
                            });
                        } else {
                            vm.documentTemplate.setFile(extension, fileSelection[0].File, false);
                        }
                    } else {
                        DialogService.alert('Selected file "' + fileSelection[0].FileName + '" is not one of the following types: ' + validFileExtensions.join(', '));
                    }
                }
            });
        }

        /**
         * Removes the document template file.
         */
        function removeTemplate() {
            vm.documentTemplate.setFile();
        }

        /**
         * Redirects the user to a view with a copy of the current document template.
         */
        function copyDocumentTemplate() {
            if (vm.documentTemplateIsNew) {
                promptUserToSaveForOperation('copying');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges('Document Template')
                        .then(function () {
                            saveDocumentTemplateValidate().then(function () {
                                $location.url('documenttemplates/new?copyDocumentTemplateId=' + vm.documentTemplate.data.Id);
                            });
                        });
                } else {
                    $location.url('documenttemplates/new?copyDocumentTemplateId=' + vm.documentTemplate.data.Id);
                }
            }
        }

        /*
         * When conducting an operation which requires a saved document template and the document template is new, a 'save document template' prompt needs to be shown
         *
         * @param {string} operationName - Name of operation that was being conducted
         */
        function promptUserToSaveForOperation(operationName) {
            return DialogService.show({
                controller: 'SaveItemDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/controls/dialog/save-item-dialog.tmpl.html',
                locals: { name: 'document template', operation: operationName }
            })
            .then(function () {
                return saveDocumentTemplateValidate();
            });
        }

        /**
         * User un-focused the name field.
         */
        function nameBlur() {
            // By default, the file name for a document template will be the same as the name
            if (!_.isNil(vm.documentTemplate.data) && (_.isNil(vm.documentTemplate.data.FileName) || vm.documentTemplate.data.FileName === '')) {
                vm.documentTemplate.data.FileName = vm.documentTemplate.data.Name;
            }
        }

        /**
         * User un-focused the description field.
         */
        function descriptionBlur() {
            // By default, the file description for a document template will be the same as the description
            if (!_.isNil(vm.documentTemplate.data) && (_.isNil(vm.documentTemplate.data.FileDescription) || vm.documentTemplate.data.FileDescription === '')) {
                vm.documentTemplate.data.FileDescription = vm.documentTemplate.data.Description;
            }
        }

        function close() {
            NavigationAidService.goBack();
        }

        /**
        * Performs a test merge
        */
        function testMerge() {
            if (vm.documentTemplateIsNew) {
                promptUserToSaveForOperation('test merge');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges('Document Template')
                        .then(function () {
                            saveDocumentTemplateValidate().then(function () {
                                vm.testMergeModel.runTestMerge(vm.documentTemplate);
                            });
                        });
                } else {
                    vm.testMergeModel.runTestMerge(vm.documentTemplate);
                }
            }
        }

        /**
         * Redirects the user to a list view of entities for the entity template.
        */
        function viewEntities() {
            if (vm.documentTemplateIsNew) {
                promptUserToSaveForOperation('viewing entities');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges('Document Template')
                        .then(function () {
                            saveDocumentTemplateValidate().then(function () {
                                $location.url('entities?entityTemplateId=' + vm.documentTemplate.data.EntityTemplateId);
                            });
                        });
                } else {
                    $location.url('entities?entityTemplateId=' + vm.documentTemplate.data.EntityTemplateId);
                }
            }
        }

        /**
         * Gets the selected entity templates name.
         */
        function getSelectedEntityTemplateName() {
            var result = 'Current Entity';

            var selectedEntityTemplate = vm.selectedEntityTemplate;
            if (!_.isNil(selectedEntityTemplate)) {
                result = selectedEntityTemplate.Name;
            }

            return result;
        }
    }
})();